module.exports = __webpack_public_path__ + "static/img/R303BT.2c31aaee.jpg";